import { render, staticRenderFns } from "./region-user-tree.vue?vue&type=template&id=01efd52a&scoped=true&"
import script from "./region-user-tree.vue?vue&type=script&lang=js&"
export * from "./region-user-tree.vue?vue&type=script&lang=js&"
import style0 from "./region-user-tree.vue?vue&type=style&index=0&id=01efd52a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01efd52a",
  null
  
)

export default component.exports